import { ExternalLink } from "lucide-react";
import { AcademyListing } from "../../../data/academyListings";

type AcademyProgramCardProps = {
  program: AcademyListing;
};

const AcademyProgramCard = ({ program }: AcademyProgramCardProps) => {
  return (
    <a
      href={program.href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open ${program.name}`}
      className="group flex h-full w-full cursor-pointer flex-col rounded-[14px] border border-transparent bg-white p-6 no-underline shadow-[0_4px_20px_rgba(21,65,94,0.08)] transition-all duration-300 ease-out hover:-translate-y-1 hover:border-[#3384C1] hover:shadow-[0_16px_36px_rgba(51,132,193,0.18)] focus:outline-none focus-visible:border-[#3384C1]"
    >
      <div
        className="relative w-full shrink-0 overflow-hidden rounded-[10px] bg-white"
        style={{ aspectRatio: "816 / 304" }}
      >
        {program.cover ? (
          <img
            src={program.cover}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
        ) : null}
      </div>

      <div className="flex flex-1 flex-col pt-5">
        <p className="truncate text-[11px] font-bold uppercase tracking-[0.1em] text-[#5E7A8D]">
          {program.kicker}
        </p>

        <h3 className="mt-2.5 text-[20px] font-bold leading-[1.35] text-[#002B49]">
          {program.name}
        </h3>

        <p
          className="mt-3 text-[14px] font-normal leading-[1.65] text-[#4A5568]"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            minHeight: "4.95em",
          }}
        >
          {program.desc}
        </p>

        <div className="mt-auto flex items-end justify-between gap-4 pt-7">
          <p className="min-w-0 text-[12px] font-normal leading-[1.45] text-[#5E7A8D]">
            {program.meta || ""}
          </p>
          <span className="inline-flex shrink-0 items-center gap-1 text-[14px] font-semibold text-[#3384C1] transition-colors duration-200 group-hover:text-[#002B49]">
            Learn More
            <ExternalLink size={15} strokeWidth={2} />
          </span>
        </div>
      </div>
    </a>
  );
};

export default AcademyProgramCard;
